import type { JSX } from 'react';
import type { SyncStatus } from '../api/schemas';
import { useLocale, useT } from '../i18n/useT';
import { formatSyncedAt } from './format';
import { useToday } from './useToday';

/**
 * Background sync state: silent when idle after a sync, so the screen stays calm. A failed sync
 * says so, since the grid may then be missing a rental.
 */
export const SyncLine = ({ sync }: { sync: SyncStatus }): JSX.Element | null => {
  const t = useT();
  const locale = useLocale();
  const today = useToday();
  if (sync.state === 'idle' && sync.lastSyncedAt !== null) {
    return null;
  }
  if (sync.state === 'running') {
    return (
      <p className="ow-sync" role="status">
        {t('Updating from the booking system…')}
      </p>
    );
  }
  if (sync.state === 'failed') {
    return (
      <p className="ow-sync ow-sync--failed" role="status">
        {sync.lastSyncedAt === null
          ? t("Couldn't update from the booking system.")
          : t("Couldn't update from the booking system. Showing bookings as of {0}.", {
              0: formatSyncedAt(sync.lastSyncedAt, today, locale)
            })}
      </p>
    );
  }
  return (
    <p className="ow-sync" role="status">
      {t('Last updated {0}', { 0: t('never') })}
    </p>
  );
};
